import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import { getTokenBoxPlotData } from "../../api/token";

import { Box, Chip, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import BPC from "../../components/BoxPlot";

const BoxPlotChart = ({ symbol }) => {

    // read from and to from url query params, they are timestamps
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');
    const to = urlParams.get('to');

    // convert to dayjs object from timestamp
    const from_date = from ? dayjs.unix(from) : dayjs().subtract(1, 'month');
    const to_date = to ? dayjs.unix(to) : dayjs();

    const [data, setData] = useState([]);
    const [config, setConfig] = useState({
        dimension: 'liquidity_rate',
        from: from_date,
        to: to_date,
    });
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = () => {
        getTokenBoxPlotData(symbol, config.dimension, config).then((data) => {
            // { x: 1, min: 2, median: 5, max: 10, q1: 3, q3: 7 }
            setData(data.map((record) => {
                return {
                    x: record.timestamp * 1000,
                    min: record.low / (10 ** 25),
                    median: record.median / (10 ** 25),
                    max: record.high / (10 ** 25),
                    q1: record.q1 / (10 ** 25),
                    q3: record.q3 / (10 ** 25),
                }
            }));
        });
    }

    useEffect(() => {
        fetchData();
    }, [config]);

    const handleChange = (key, value) => {
    setConfig((prev) => ({
        ...prev,
        [key]: value,
    }));
    }

    const handleDateChange = (type, date) => {
        // update url query params
        const timestamp = date.unix();
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(type, timestamp);
        window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
        handleChange(type, date);
    };
    


    return (
        <Box>
        <Box sx={{
        width: '100%', 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'center', 
        alignItems: 'center', 
        mb: 2, 
        gap: 2, 
        backgroundColor: 'var(--background-color)',
        pt: 2,
        pb: 1,
        }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
            sx={{marginTop: 2}}
            label="From Date"
            value={config.from}
            onChange={(newValue) => handleDateChange('from', newValue)}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
            />
            <DatePicker
            sx={{marginTop: 3}}
            label="To Date"
            value={config.to}
            onChange={(newValue) => handleDateChange('to', newValue)}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
            />
        </LocalizationProvider>
        </Box>
        <BPC
        data={data}
        isLoading={isLoading}
        filter={
        <Box>
            <Box sx={{ mt: 1 }}>
            <FormControl fullWidth margin="normal">
            <InputLabel id="dimension-select-label">Dimension</InputLabel>
            <Select
                labelId="dimension-select-label"
                value={config.dimension}
                onChange={(e) => handleChange('dimension', e.target.value)}
                label="Dimension"
            >
                <MenuItem key="liquidity_rate" value="liquidity_rate">Liquidity Rate</MenuItem>
                <MenuItem key="variable_borrow_rate" value="variable_borrow_rate">Variable Borrow Rate</MenuItem>
                <MenuItem key="stable_borrow_rate" value="stable_borrow_rate">Stable Borrow Rate</MenuItem>
            </Select>
            </FormControl>
            </Box>  
        </Box>
        }
    />
    </Box>);
}

export default BoxPlotChart;